import { Component, Input } from '@angular/core';
import { ComponentSubHtmlBase } from '../component-sub-html-base/component-sub-html-base.component';
import { CountryDto } from 'src/app/data-transfer/entities/country-dto';

@Component({
  selector: 'app-component-sub-html-template',
  templateUrl: './component-sub-html-template.component.html',
  styleUrls: ['./component-sub-html-template.component.scss'],
})
export class ComponentSubHtmlTemplateComponent extends ComponentSubHtmlBase {
  @Input() distributionCountries: CountryDto[] = [];

  get distributionCountryCodes(): string[] {
    return this.distributionCountries.map(c => c.code);
  }
}
